import {useConfig} from '@aboutyou/config';
import {DataFetcher, PriorityConfig} from '@aboutyou/data-fetcher';
import {useIsFeatureActive} from '@aboutyou/feature-flags';
import React from 'react';
import {useNotifications} from '../../NotificationCenter/NotificationProvider';
import {useDiscounts} from '../hooks/useDiscounts';
import {
  DiscountBannerView,
  DiscountBannerViewProps,
} from './DiscountBannerView';
import {NotificationBannerView} from './NotificationBannerView';

export const DiscountBanner: React.FC<
  PriorityConfig & DiscountBannerViewProps & {showHeroNotification?: boolean}
> = ({renderingPriority, showHeroNotification, ...viewProps}) => {
  const discounts = useDiscounts();
  const {isActive: isBasHugoTakeoverActive} = useIsFeatureActive(
    'bas_homepage_campaign_hugo',
  );
  const {device} = useConfig();
  const {notificationsData} = useNotifications();

  if (
    discounts.data?.discounts.length ||
    (isBasHugoTakeoverActive && device === 'desktop')
  ) {
    return (
      <DataFetcher
        request={discounts}
        Error={null}
        renderingPriority={renderingPriority}
        View={DiscountBannerView}
        viewProps={viewProps}
      />
    );
  }

  if (showHeroNotification && notificationsData) {
    return <NotificationBannerView {...notificationsData} {...viewProps} />;
  }

  return null;
};
